import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=2609a5e3&"
import script from "./Collection.vue?vue&type=script&lang=ts&"
export * from "./Collection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports